"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _qrcode = _interopRequireDefault(require("qrcode.react"));

var _modal = _interopRequireDefault(require("./modal"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _indexModule = _interopRequireDefault(require("../static/styles/index.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind.default.bind(_indexModule.default);

const ERROR = 'User denied to autheticate';

class getAuthentication extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "onClose", () => {
      this.setState({
        visible: false,
        qrcode: null
      }, () => {
        this.props.done(ERROR, null);
      });
    });

    this.state = {
      visible: this.props.visible,
      qrcode: this.props.qrcode
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible) {
      this.setState({
        visible: this.props.visible,
        qrcode: this.props.qrcode
      });
    }
  }

  render() {
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      visible: this.state.visible,
      className: cx("fade", "wallet-modal", "hybrid-wallet"),
      dialogClassName: cx("modal-dialog-centered")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: cx("modal-body")
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: cx("close-button"),
      onClick: () => {
        this.onClose();
      }
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: cx("title", "d-block", "text-center", "mt-4")
    }, "Authentication"), /*#__PURE__*/_react.default.createElement("p", {
      className: cx("subtitle", "d-block", "text-center", "mb-4")
    }, "Please use your device to scan and establish the connection!"), /*#__PURE__*/_react.default.createElement("div", {
      className: cx("qr-code", "mx-auto", "my-5")
    }, this.state.qrcode ? /*#__PURE__*/_react.default.createElement(_qrcode.default, {
      size: 200,
      value: this.state.qrcode
    }) : null)));
  }

}

var _default = getAuthentication;
exports.default = _default;